export default __webpack_public_path__ + "static/media/0p.bb39d606.png";